import api from '../helpers/api'

export const getAlertConfigs = (metricType: string) => api.get(`/configs/alerts/${metricType}`)
export const saveAlertConfig = (metricType: string, config: any) => api.post(`/configs/alerts/${metricType}`, config)
export const editAlertConfig = (metricType: string, config: any, id: number) => api.patch(`/configs/alerts/${metricType}/${id}`, config)
export const deleteAlertConfig = (metricType:string, id: number) => api.delete(`/configs/alerts/${metricType}/${id}`)

export const getAlerts = (metricType: string, id: number) => api.get(`/alerts/${metricType}?alert_config_id=${id}`)
